import { sendMessageAPI, getMessageAPI, updateMessageAPI, deleteMessageAPI, replyMessageAPI, updateMessageReplyReadAPI } from "./api";

export const sendMessage = (data) => {
  return new Promise((resolve, reject) => {
    sendMessageAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const replyMessage = (params, data) => {
  return new Promise((resolve, reject) => {
    replyMessageAPI(params, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMessage = (data) => {
  return new Promise((resolve, reject) => {
    getMessageAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateMessageReplyRead = (params) => {
    return new Promise((resolve, reject) => {
        updateMessageReplyReadAPI(params)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
}

export const updateMessage = (id, data) => {
    return new Promise((resolve, reject) => {
        updateMessageAPI(id, data)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
}

export const deleteMessage = (id) =>{
    return new Promise((resolve, reject) => {
        deleteMessageAPI(id)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
    });
}